import React, { useMemo } from 'react';
import styles from './BetLineStatus.module.scss';
import { renderTicketStatusName } from '../../../../../../../utils/render';
import { TICKET_STATUSES } from '../../../../../../../constants/enums';

const BetLineStatus = ({ statusId }) => {
    const statusName = useMemo(() => {
        let name = '';
        switch (statusId) {
            case TICKET_STATUSES.open:
                name = 'open';
                break;
            case TICKET_STATUSES.cancelled:
                name = 'cancelled';
                break;
            case TICKET_STATUSES.won:
                name = 'won';
                break;
            case TICKET_STATUSES.lost:
                name = 'lost';
                break;
            case TICKET_STATUSES.draw:
                name = 'draw';
                break;
            case TICKET_STATUSES.void:
                name = 'void';
                break;
            case TICKET_STATUSES.refunded:
                name = 'refunded';
                break;
            case TICKET_STATUSES.cashOut:
                name = 'cashOut';
                break;
            default:
                break;
        }
        return name;
    }, [statusId]);

    return (
        <div className={styles.betLineStatus}>
            <span className={`${styles.icon} ${styles[statusName]}`} />
            <span className={'f-s-12'}>{renderTicketStatusName(statusId)}</span>
        </div>
    );
};

export default BetLineStatus;
